import { aboutData } from "@/mocks/about";

export default function BrandHero() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Dark%20dramatic%20journalism%20newsroom%20scene%2C%20empty%20editorial%20office%20with%20red%20ambient%20lighting%2C%20vintage%20typewriters%20and%20newspapers%2C%20cinematic%20noir%20atmosphere%2C%20deep%20blacks%20and%20crimson%20accents%2C%20professional%20fine%20art%20photography%2C%20dramatic%20shadows%2C%20moody%20lighting%2C%20editorial%20style&width=1920&height=1080&seq=about-hero-bg&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center justify-center text-center pt-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-foreground-50 leading-tight mb-6">
            {aboutData.heroTitle}
          </h1>
          <p className="text-base md:text-lg text-foreground-300 mb-10 max-w-2xl mx-auto leading-relaxed">
            {aboutData.heroSubtitle}
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full pb-8 md:pb-12 z-10">
        <p className="text-4xl md:text-6xl lg:text-8xl font-heading font-black text-foreground-50/10 text-center whitespace-nowrap px-4 select-none">
          {aboutData.brandName}
        </p>
      </div>
    </section>
  );
}